import '@shui/core/sh-user-identifier';

import { Component, input, booleanAttribute, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-user-identifier',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.accessible-label]': 'accessibleLabel() ?? null',
        '[attr.active]': 'active() ? "" : null',
        '[attr.condensed]': 'condensed() ? "" : null',
        '[attr.image]': 'image() ?? null',
        '[attr.info]': 'info() ?? null',
        '[attr.initials]': 'initials() ?? null',
        '[attr.name]': 'name() ?? null',
        '[attr.readonly]': 'readonly() ? "" : null',
        '[attr.toggle]': 'toggle() ? "" : null',
        '[attr.unauthenticated]': 'unauthenticated() ? "" : null'
    }
})
export class ShUserIdentifierComponent {
    /** Defines the aria-label attribute for the user identifier. */
    public readonly accessibleLabel = input<string | number | undefined>(undefined);

    /** Sets the active (toggled/selected) visual state of the component. */
    public readonly active = input(false, { transform: booleanAttribute });

    /** If set to `true`, condensed style is applied. */
    public readonly condensed = input(false, { transform: booleanAttribute });

    /** Defines the profile picture. If left undefined a placeholder icon will be shown. */
    public readonly image = input<string | number | undefined>(undefined);

    /**
     * Defined the info text shown below the user name. Will only be shown if the name property is
     * also defined.
     */
    public readonly info = input<string | number | undefined>(undefined);

    /**
     * Defines the initials shown inside the circle (up to 2 characters). If not defined, the first
     * and last initials of the name will be displayed automatically.
     */
    public readonly initials = input<string | number | undefined>(undefined);

    /**
     * Defines the user name shown to the right side of the picture. If let undefined, only the
     * image will be shown.
     */
    public readonly name = input<string | number | undefined>(undefined);

    /**
     * If set to `true`, component becomes a representation-only element with no interaction states
     * or events.
     */
    public readonly readonly = input(false, { transform: booleanAttribute });

    /** If set to `true`, enables toggle behavior. */
    public readonly toggle = input(false, { transform: booleanAttribute });

    /**
     * If set to `true`, will display a placeholder icon with or without the surrounding circle,
     * depending on the definition of the name property.
     */
    public readonly unauthenticated = input(false, { transform: booleanAttribute });
}
